import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { QuestionnaireService } from '@app/services/questionnaire.service';
import { LoadingProvider } from 'app/components/_shared/loading-spinner/loading-spinner.component';
import { LocaleDataIndex } from '@angular/common/src/i18n/locale_data';

@Component({
  selector: 'app-register-complete',
  templateUrl: './register-complete.component.html',
  styleUrls: ['./register-complete.component.scss']
})
export class RegisterCompleteComponent implements OnInit {
  static route: string = 'registration-complete';

  locale: any = {};
  introText: string = '';

  constructor(
    private router: Router,
    private localisation: LocalisationService,
    private questionnaireService: QuestionnaireService,
    private authService: AuthService,
    private spinner: LoadingProvider
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('RegisterCompleteComponent');
    this.spinner.show(this.locale.findingYourAccount, true);

    this.introText =
      sessionStorage.getItem('freeRedeemed') == 'true' ? this.locale.freeRedeemed + '\n\n' : '';
    this.introText += this.locale.mainText;

    this.questionnaireService
      .getQuestionnaireStatus()
      .finally(() => {
        this.spinner.hide();
      })
      .subscribe(Response => {});
  }

  goToStart() {
    this.router.navigateByUrl('/centigrade/questions');
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/register-complete/register-complete.component.ts